import api from '../../api';
import config from '../../config';
const { DOMAIN_KEY } = process.env;
export default {
    post: (data) => {
        return api.request('post',config.default.loginUrl, null, null, data)
    }
}